// ===========================================
// Password Section Component
// ===========================================

import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { CARD_COLORS } from './account.constants';

interface Props {
  lastPasswordChange: string | null | undefined;
  isFunMode: boolean;
  onOpenPasswordDialog: () => void;
}

export default function PasswordSection({
  lastPasswordChange,
  isFunMode,
  onOpenPasswordDialog,
}: Props) {
  return (
    <Card
      sx={{
        mb: 3,
        ...(isFunMode && {
          borderRadius: 4,
          border: `3px solid ${CARD_COLORS.password.border}`,
          bgcolor: CARD_COLORS.password.bg,
          boxShadow: '4px 4px 0px rgba(0,0,0,0.08)',
        }),
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <Box
            sx={{
              bgcolor: isFunMode ? `${CARD_COLORS.password.border}30` : 'warning.light',
              borderRadius: '50%',
              width: 48,
              height: 48,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: isFunMode ? CARD_COLORS.password.border : 'warning.dark',
              flexShrink: 0,
            }}
          >
            <LockIcon />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6">Password & Security</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Keep your account secure by using a strong password.
              {lastPasswordChange && (
                <> Last changed: {new Date(lastPasswordChange).toLocaleDateString()}</>
              )}
            </Typography>
            <Button
              variant="outlined"
              startIcon={<LockIcon />}
              onClick={onOpenPasswordDialog}
            >
              Change Password
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
